import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-qdialog',
    templateUrl: './qdialog.component.html',
    styleUrl: './qdialog.component.css',
    standalone: false
})
export class QDialogComponent {
  reason: string = '';

  constructor(public dialogRef: MatDialogRef<QDialogComponent>) {}

  submit() {
    this.dialogRef.close(this.reason); // pass the reason back
  }

  cancel() {
    this.dialogRef.close(); // close without a value
  }
}
